import Emitter from './Emitter';

export default class Reference extends Emitter {
  constructor() {
    super();
    this.__data = {};
  }

  get data() {
    return Object
      .values(this.__data)
      .reduce((acc, value) => {
        acc[value.name] = value.item?.value || null;
        return acc;
      }, {});
  }


  set(key, item, name) {
    this.unsub(key);
    this.__data[key] = {
      item,
      name: name || key,
      unsub: item.$subscribe(() => {
        this.$dispatch(this.data);
      }),
    };
  }

  get(key) {
    const item = this.__data[key];
    return item.value;
  }

  unsub(key) {
    const item = this.__data[key];
    if (item && item.unsub) {
      item.unsub();
    }
  }

  delete(key) {
    this.unsub(key);
    this.__data[key] = null;
  }
}
